module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxMEMwLjUgNC43NTMzIDQuNzUzMyAwLjUgMTAgMC41QzE1LjI0NjcgMC41IDE5LjUgNC43NTMzIDE5LjUgMTBDMTkuNSAxNS4yNDY3IDE1LjI0NjcgMTkuNSAxMCAxOS41QzQuNzUzMyAxOS41IDAuNSAxNS4yNDY3IDAuNSAxMFoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMxRDFEMUQiLz4KPHBhdGggZD0iTTcgMTAuNUM3IDEwLjUgOC43MjM0NCAxMi41IDkgMTIuNUM5LjI3NjU2IDEyLjUgMTMgNyAxMyA3IiBzdHJva2U9IiMwMDcwNzUiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/accept.svg
// module id = TAik
// module chunks = 1